export const onBookMeeting = () => {
  // eslint-disable-next-line no-undef
  Calendly.initPopupWidget({
    url: "https://calendly.com/minuitagency/30min",
  });
  return false;
};
